import Employee from 'models/employee';
import OrgObjective from 'models/orgObjective';
import { PostActions } from 'models/postFeedItemData';

export default class Objective {
  constructor({
    id,
    active,
    uuid,
    createdTS,
    updatedTS,
    from,
    macros,
    type,
    parentPost,
    actions,
    toIds,
    lastEditedBy,
    status,
    uiKey,
    objectiveTimeBound = null,
  }) {
    this.id = id;
    this.active = active;
    this.uuid = uuid;
    this.createdTS = createdTS;
    this.updatedTS = updatedTS;
    this.from = from;
    this.macros = macros;
    this.type = type;
    this.parentPost = parentPost;
    this.actions = actions;
    this.toIds = toIds;
    this.lastEditedBy = lastEditedBy;
    this.status = status;
    this.uiKey = uiKey;
    this.objectiveTimeBound = objectiveTimeBound;
  }

  static fromJSON(json) {
    if (!json) return;

    const getMappedToIds = (toIds = []) => {
      const toOnlyIdsObject = {};
      const mappedToIds = [];
      toIds.forEach((employee) => {
        if (!toOnlyIdsObject[employee.uuid]) {
          const newEmployee = new Employee();
          newEmployee.fromJSON(employee);
          mappedToIds.push(newEmployee);
        }
      });

      return mappedToIds;
    };

    const {
      id,
      active,
      uuid,
      createdTS,
      updatedTS,
      from,
      macros,
      type,
      parentPost,
      actions,
      toIds,
      lastEditedBy,
      status,
      uiKey,
      objectiveTimeBound = null,
    } = json;

    const fromEmployee = new Employee();
    if (typeof from === 'object') {
      fromEmployee.fromJSON(from);
    }

    return new Objective({
      id,
      active,
      uuid,
      createdTS,
      updatedTS,
      from: typeof from === 'object' ? fromEmployee : null,
      macros,
      type,
      parentPost,
      actions: PostActions.fromJSON({
        actionsJSON: actions,
        type: 'OBJECTIVE',
        isContentStatePresent: true,
      }),
      toIds: getMappedToIds(toIds),
      lastEditedBy,
      status,
      uiKey,
      objectiveTimeBound: OrgObjective.fromJSON(objectiveTimeBound),
    });
  }
}
